/**
 * MrrHero — тёмная карточка MRR для мобилки: подпись, зелёная дельта, крупная
 * сумма и светлый спарклайн.
 */

import {ChevronUp} from 'lucide-react';

import type {DashboardSummary} from '@services/dashboard';

import {fmtMln, fmtPct} from '../../Dashboard.utils';
import {Sparkline} from '../../Sparkline';

type MrrHeroProps = {mrr: DashboardSummary['mrr']};

export const MrrHero = ({mrr}: MrrHeroProps) => (
  <div className="rounded-2xl bg-skr-dark px-[18px] py-[17px] text-white">
    <div className="flex items-center justify-between">
      <div className="text-[12.5px] text-[#A9B0BE]">MRR · месячная выручка</div>
      <span className="inline-flex items-center gap-[3px] rounded-full bg-skr-toast-dot/15 px-[7px] py-0.5 text-xs font-semibold text-skr-toast-dot">
        <ChevronUp className="size-[11px]" strokeWidth={3} />
        {fmtPct(mrr.deltaPct)}%
      </span>
    </div>
    <div className="mt-2 whitespace-nowrap font-mono text-[32px] font-semibold -tracking-[.02em]">
      {fmtMln(mrr.value)}
      <span className="text-lg text-[#8B93A3]">М</span>{' '}
      <span className="text-[13px] text-[#8B93A3]">сом</span>
    </div>
    <div className="mt-2.5">
      <Sparkline points={mrr.spark} tone="light" />
    </div>
  </div>
);
